export default __webpack_public_path__ + "static/media/gallery11.f3563976.jpg";